import { SproutAutomationSettings } from "verdi-common/schemas/device/subSchemas/sproutAutomationSettings";
import type MapEntityBase from "../../../map-management/map-entities/map-entity-base";
import { doesDeviceVersionMatch, GENERATION_CODE } from "../../versions-code";
import { AUTOMATION_MODE } from "./definitions";

export const getAutomationMode = ({ model }: { model: MapEntityBase["model"] }) => {
    const isSproutDevice = doesDeviceVersionMatch(model, { generation: GENERATION_CODE.SPROUT });

    if (isSproutDevice && model.sproutAutomationSettings) {
        return model.sproutAutomationSettings?.automationMode as (typeof AUTOMATION_MODE)[keyof typeof AUTOMATION_MODE];
    }

    return AUTOMATION_MODE.DISABLED;
};

export const isAutomationEnabled = ({ model }: { model: MapEntityBase["model"] }) => {
    const automationMode = getAutomationMode({ model });
    return automationMode !== AUTOMATION_MODE.DISABLED;
};

export const getAutomationInfo = ({ model }: { model: MapEntityBase["model"] }) => {
    const isSproutDevice = doesDeviceVersionMatch(model, { generation: GENERATION_CODE.SPROUT });

    if (isSproutDevice) {
        return model.sproutAutomationSettings as SproutAutomationSettings;
    }

    return null;
};
